import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { readPreformTrend, readPreformContrast, readPreformOrderReport, readPreformReportTable } from '@/service/preform-count';
import { CHAR } from '@/config/common';
var ratioTabs = {
  volume: '销量',
  money: '金额'
};
export default function usePreformCountComprehensive() {
  // 统计
  var countLoading = ref(false);
  var summary = ref({
    proValue: CHAR.NUL,
    preformFreight: CHAR.NUL,
    preformCarNumber: CHAR.NUL
  });
  var summaryMap = ref({
    proValue: '总盘料量/吨',
    preformFreight: '总运费/万元',
    preformCarNumber: '总单数/单'
  });
  function getPreformOrderReport(_x) {
    return _getPreformOrderReport.apply(this, arguments);
  } // 比例
  function _getPreformOrderReport() {
    _getPreformOrderReport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            countLoading.value = true;
            _context.next = 3;
            return readPreformOrderReport(params);
          case 3:
            data = _context.sent;
            countLoading.value = false;
            summary.value = data;
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _getPreformOrderReport.apply(this, arguments);
  }
  var ratioLoading = ref(false);
  var ratioUnits = reactive({
    volume: '吨',
    money: '万元'
  });
  var contrastData = ref([]);
  function getPreformContrast(_x2, _x3) {
    return _getPreformContrast.apply(this, arguments);
  } // 统计明细
  function _getPreformContrast() {
    _getPreformContrast = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params, type) {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            ratioLoading.value = true;
            _context2.next = 3;
            return readPreformContrast(params);
          case 3:
            data = _context2.sent;
            ratioLoading.value = false;
            if (_.eq(type, 'volume')) {
              contrastData.value = data.feedWeight;
            } else {
              contrastData.value = data.feedFreight;
            }
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _getPreformContrast.apply(this, arguments);
  }
  var countDetails = ref([]);
  function getPreformReportTable(_x4) {
    return _getPreformReportTable.apply(this, arguments);
  } // 趋势
  function _getPreformReportTable() {
    _getPreformReportTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(params) {
      var data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            ratioLoading.value = true;
            _context3.next = 3;
            return readPreformReportTable(params);
          case 3:
            data = _context3.sent;
            ratioLoading.value = false;
            countDetails.value = data.list;
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _getPreformReportTable.apply(this, arguments);
  }
  var trendsLoading = ref(false);
  var trends = ref([]);
  function getPreformTrend(_x5) {
    return _getPreformTrend.apply(this, arguments);
  } // 记录
  // const records = ref<ReadPreformSearchPagelistItem[]>([]);
  // async function getPreformSearchPagelist(
  //   params: ReadPreformSearchPagelistParams
  // ) {
  //   const data = await readPreformSearchPagelist(params);
  //   records.value = data.list;
  // }
  // // 记录-日
  // const recordsByDay = ref<ReadPreformSearchByDayItem[]>([]);
  // async function getPreformSearchByDay(params: ReadPreformSearchByDayParams) {
  //   const data = await readPreformSearchByDay(params);
  //   recordsByDay.value = data.list;
  // }
  // 记录-周、月、自定义
  function _getPreformTrend() {
    _getPreformTrend = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(params) {
      var data;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            trendsLoading.value = true;
            _context4.next = 3;
            return readPreformTrend(params);
          case 3:
            data = _context4.sent;
            trendsLoading.value = false;
            trends.value = data.list;
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _getPreformTrend.apply(this, arguments);
  }
  return {
    trends: trends,
    // records,
    ratioTabs: ratioTabs,
    ratioUnits: ratioUnits,
    summary: summary,
    summaryMap: summaryMap,
    countDetails: countDetails,
    // recordsByDay,
    countLoading: countLoading,
    ratioLoading: ratioLoading,
    contrastData: contrastData,
    trendsLoading: trendsLoading,
    // recordsByTime,
    getPreformTrend: getPreformTrend,
    getPreformContrast: getPreformContrast,
    getPreformReportTable: getPreformReportTable,
    // getPreformSearchByDay,
    getPreformOrderReport: getPreformOrderReport
    // getPreformSearchByTime
    // getPreformSearchPagelist
  };
}